import { render, staticRenderFns } from "./RoundIcon.vue?vue&type=template&id=48a60d44&scoped=true"
import script from "./RoundIcon.vue?vue&type=script&lang=js"
export * from "./RoundIcon.vue?vue&type=script&lang=js"
import style0 from "./RoundIcon.vue?vue&type=style&index=0&id=48a60d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a60d44",
  null
  
)

export default component.exports